import { FilterDomainWire } from '../types';
import { DefaultFilter, FilterState } from '../types-store';

export const mapFilterDomainsToFilter = (wire: FilterDomainWire): DefaultFilter[] => {
  return wire?.filterDomain?.map(filter => ({
    domain: {
      value: filter.domain,
      description: filter.label
    },
    required: false,
    sequence: filter.sequence,
    myValue: false,
    defaultValue: undefined,
    defaultValue2: undefined,
    periodPredef: undefined,
    state: FilterState.NoDefaultValue
  })) ?? [];
};
